<template>
  <form
    method="POST"
    :action="`/api/media/download/${format}`"
  >
    <v-btn
      v-if="iconPos === 'left'"
      v-bind="btnProps"
      type="submit"
    >
      <slot />
      {{ text }}
    </v-btn>

    <v-btn
      v-if="iconPos === 'right'"
      v-bind="btnProps"
      type="submit"
    >
      {{ text }}
      <slot />
    </v-btn>

    <input
      type="hidden"
      name="json"
      :value="JSON.stringify(json)"
    >
    <input
      type="hidden"
      name="token"
      :value="$store.state.user.token"
    >
  </form>
</template>

<script>
export default {
  props: ['format', 'json', 'btnProps', 'text', 'iconPos'],
};
</script>
